"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Types = _interopRequireWildcard(require("../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var FieldContextReducer = function FieldContextReducer(state, action) {
  var _a, _b;
  switch (action === null || action === void 0 ? void 0 : action.type) {
    case Types.FieldContext.ReducerActionTypes.SetIsRequired:
      return __assign(__assign({}, state), {
        isRequired: action === null || action === void 0 ? void 0 : action.payload
      });
    case Types.FieldContext.ReducerActionTypes.SetFieldName:
      return __assign(__assign({}, state), {
        fieldName: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.fieldName,
        label: (_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.label
      });
    case Types.FieldContext.ReducerActionTypes.SetShowDefaultLabel:
      return __assign(__assign({}, state), {
        showDefaultLabel: action === null || action === void 0 ? void 0 : action.payload
      });
    case Types.FieldContext.ReducerActionTypes.SetValidateOnChange:
      return __assign(__assign({}, state), {
        validateOnChange: action === null || action === void 0 ? void 0 : action.payload
      });
    default:
      return __assign({}, state);
  }
};
var _default = FieldContextReducer;
exports.default = _default;